// Device-local preference: show the Monday reveal on startup. Off by default.
import AsyncStorage from '@react-native-async-storage/async-storage';

const key = (userId: string) => `olmps.mondayReveal.enabled.${userId}`;

export async function getRevealEnabled(userId: string): Promise<boolean> {
  try {
    return (await AsyncStorage.getItem(key(userId))) === '1';
  } catch {
    return false;
  }
}

export async function setRevealEnabled(userId: string, on: boolean): Promise<void> {
  try {
    await AsyncStorage.setItem(key(userId), on ? '1' : '0');
  } catch {
    /* best-effort */
  }
}
